/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminEbayAccountResp,
    AdminEbayAccountRespFromJSON,
    AdminEbayAccountRespToJSON,
    AdminEbayCategoryResp,
    AdminEbayCategoryRespFromJSON,
    AdminEbayCategoryRespToJSON,
    AdminEbayCategorySuggestionsResp,
    AdminEbayCategorySuggestionsRespFromJSON,
    AdminEbayCategorySuggestionsRespToJSON,
    AdminEbayConnectReq,
    AdminEbayConnectReqFromJSON,
    AdminEbayConnectReqToJSON,
    AdminEbayConnectUrlResp,
    AdminEbayConnectUrlRespFromJSON,
    AdminEbayConnectUrlRespToJSON,
    AdminEbayDraftReq,
    AdminEbayDraftReqFromJSON,
    AdminEbayDraftReqToJSON,
    AdminEbayListing,
    AdminEbayListingFromJSON,
    AdminEbayListingToJSON,
    AdminEbaySellingLimitResp,
    AdminEbaySellingLimitRespFromJSON,
    AdminEbaySellingLimitRespToJSON,
    AdminEbaySetupReq,
    AdminEbaySetupReqFromJSON,
    AdminEbaySetupReqToJSON,
} from '../models';

export interface AdminEbayApiAdminEbayCategorySuggestionsRequest {
    q: string;
}

export interface AdminEbayApiAdminEbayConnectRequest {
    params: AdminEbayConnectReq;
}

export interface AdminEbayApiAdminEbayDeleteDraftRequest {
    productId: string;
}

export interface AdminEbayApiAdminEbayEndRequest {
    id: string;
}

export interface AdminEbayApiAdminEbayListingRequest {
    id: string;
}

export interface AdminEbayApiAdminEbayProductCategoryRequest {
    id: string;
    categoryId: string;
}

export interface AdminEbayApiAdminEbayPublishRequest {
    id: string;
}

export interface AdminEbayApiAdminEbaySaveDraftRequest {
    id: string;
    params: AdminEbayDraftReq;
}

export interface AdminEbayApiAdminEbaySetupRequest {
    params: AdminEbaySetupReq;
}

export function createAdminEbayAccountPath(): string {
    return `/admin/ebay/account`;
}
export function createAdminEbayAccountFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/account`;
}
export function createAdminEbayCategorySuggestionsPath(): string {
    return `/admin/ebay/categories/suggest`;
}
export function createAdminEbayCategorySuggestionsFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/categories/suggest`;
}
export function createAdminEbayConnectPath(): string {
    return `/admin/ebay/connect`;
}
export function createAdminEbayConnectFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/connect`;
}
export function createAdminEbayConnectUrlPath(): string {
    return `/admin/ebay/connect-url`;
}
export function createAdminEbayConnectUrlFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/connect-url`;
}
export function createAdminEbayDeleteDraftPath(productId: string): string {
    return `/admin/products/{product_id}/ebay`.replace(`{${'product_id'}}`, encodeURIComponent(productId));
}
export function createAdminEbayDeleteDraftFullPath(productId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{product_id}/ebay`.replace(`{${'product_id'}}`, encodeURIComponent(productId))
    );
}
export function createAdminEbayDisconnectPath(): string {
    return `/admin/ebay/account`;
}
export function createAdminEbayDisconnectFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/account`;
}
export function createAdminEbayEndPath(id: string): string {
    return `/admin/products/{id}/ebay/end`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbayEndFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/ebay/end`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbayListingPath(id: string): string {
    return `/admin/products/{id}/ebay`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbayListingFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/ebay`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbayProductCategoryPath(id: string, categoryId: string): string {
    return `/admin/products/{id}/ebay/categories/{category_id}`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'category_id'}}`, encodeURIComponent(categoryId));
}
export function createAdminEbayProductCategoryFullPath(id: string, categoryId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{id}/ebay/categories/{category_id}`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'category_id'}}`, encodeURIComponent(categoryId))
    );
}
export function createAdminEbayPublishPath(id: string): string {
    return `/admin/products/{id}/ebay/publish`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbayPublishFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/ebay/publish`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbaySaveDraftPath(id: string): string {
    return `/admin/products/{id}/ebay`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbaySaveDraftFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/ebay`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminEbaySellingLimitPath(): string {
    return `/admin/ebay/account/selling-limit`;
}
export function createAdminEbaySellingLimitFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/account/selling-limit`;
}
export function createAdminEbaySetupPath(): string {
    return `/admin/ebay/setup`;
}
export function createAdminEbaySetupFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/setup`;
}
export function createAdminEbayVerifyPath(): string {
    return `/admin/ebay/account/verify`;
}
export function createAdminEbayVerifyFullPath(): string {
    return runtime.BASE_PATH + `/admin/ebay/account/verify`;
}

/**
 *
 */
export class AdminEbayApi extends runtime.BaseAPI {
    /**
     * Whether selling on eBay is configured, in which environment (sandbox or production), and the connected seller account.
     * Connected eBay seller account
     */
    async adminEbayAccount(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayAccountResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayAccountPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayAccountRespFromJSON(jsonValue))
        );
    }
    /**
     * Leaf categories of the production eBay category tree matching the query, most relevant first. Category IDs are the same in the sandbox.
     * Suggest eBay categories
     */
    async adminEbayCategorySuggestions(
        requestParameters: AdminEbayApiAdminEbayCategorySuggestionsRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayCategorySuggestionsResp>> {
        if (requestParameters?.q === null || requestParameters?.q === undefined) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter requestParameters.q was null or undefined when calling adminEbayCategorySuggestions.'
            );
        }

        const queryParameters: any = {};

        if (requestParameters?.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayCategorySuggestionsPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) =>
                      AdminEbayCategorySuggestionsRespFromJSON(jsonValue)
                  )
        );
    }
    /**
     * Finishes the sign-in: exchanges the authorization code for the account\'s tokens and stores them. Replaces the account connected before.
     * Connect the eBay seller account
     */
    async adminEbayConnect(
        requestParameters: AdminEbayApiAdminEbayConnectRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayAccountResp>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminEbayConnect.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayConnectPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminEbayConnectReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayAccountRespFromJSON(jsonValue))
        );
    }
    /**
     * The eBay page where the seller account signs in and grants access. Afterwards eBay opens a page whose address carries the authorization code; send it to /admin/ebay/connect within 5 minutes.
     * eBay sign-in page
     */
    async adminEbayConnectUrl(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayConnectUrlResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayConnectUrlPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayConnectUrlRespFromJSON(jsonValue))
        );
    }
    /**
     * Forgets a draft that was never published.
     * Delete the product\'s eBay draft
     */
    async adminEbayDeleteDraft(
        requestParameters: AdminEbayApiAdminEbayDeleteDraftRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.productId === null || requestParameters?.productId === undefined) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter requestParameters.productId was null or undefined when calling adminEbayDeleteDraft.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayDeleteDraftPath(String(requestParameters?.productId)),
                    method: 'DELETE',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Forgets the stored sign-in. eBay keeps the grant until it expires; the account owner can revoke it in the eBay account settings.
     * Disconnect the eBay seller account
     */
    async adminEbayDisconnect(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayDisconnectPath(),
                    method: 'DELETE',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Queues ending the live listing (status ending, then ended); the offer stays on eBay, so the listing can be relisted.
     * End the product\'s eBay listing
     */
    async adminEbayEnd(
        requestParameters: AdminEbayApiAdminEbayEndRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayListing>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminEbayEnd.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayEndPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayListingFromJSON(jsonValue))
        );
    }
    /**
     * The saved eBay listing of the product, or a draft filled from the product when nothing is saved yet, with the suggested price and what keeps it from being published.
     * The product\'s eBay listing
     */
    async adminEbayListing(
        requestParameters: AdminEbayApiAdminEbayListingRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayListing>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminEbayListing.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayListingPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayListingFromJSON(jsonValue))
        );
    }
    /**
     * Item specifics and conditions of the category, and the product\'s condition mapped to one the category accepts.
     * eBay category for a product
     */
    async adminEbayProductCategory(
        requestParameters: AdminEbayApiAdminEbayProductCategoryRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayCategoryResp>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminEbayProductCategory.'
            );
        }

        if (requestParameters?.categoryId === null || requestParameters?.categoryId === undefined) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter requestParameters.categoryId was null or undefined when calling adminEbayProductCategory.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayProductCategoryPath(
                        String(requestParameters?.id),
                        String(requestParameters?.categoryId)
                    ),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayCategoryRespFromJSON(jsonValue))
        );
    }
    /**
     * Queues the saved draft (or an ended listing: relist) for publishing when nothing is missing; the worker uploads the photos and publishes the offer, and the listing\'s status turns active (or error with lastError). A relisted item gets a new eBay item number.
     * Publish the product\'s eBay listing
     */
    async adminEbayPublish(
        requestParameters: AdminEbayApiAdminEbayPublishRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayListing>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminEbayPublish.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayPublishPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayListingFromJSON(jsonValue))
        );
    }
    /**
     * Saves the draft, complete or not; problems in the response tell what publishing still needs. Saving a live listing sends the changes to eBay (status updating, then active); it has to be complete. A listing being published, updated or ended cannot be saved.
     * Save the product\'s eBay draft
     */
    async adminEbaySaveDraft(
        requestParameters: AdminEbayApiAdminEbaySaveDraftRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayListing>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminEbaySaveDraft.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminEbaySaveDraft.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbaySaveDraftPath(String(requestParameters?.id)),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminEbayDraftReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayListingFromJSON(jsonValue))
        );
    }
    /**
     * The connected account\'s monthly limit on items and total amount listed and sold, and what is left of it this month, read from eBay.
     * Monthly selling limit of the eBay account
     */
    async adminEbaySellingLimit(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbaySellingLimitResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbaySellingLimitPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbaySellingLimitRespFromJSON(jsonValue))
        );
    }
    /**
     * Opts the connected account in to business policies, creates or updates our shipping (USPS Ground Advantage, free by default), payment and return (30 days, buyer pays) policies and the inventory location listings ship from. Safe to run again, e.g. to change the handling time.
     * Set up the eBay account for publishing
     */
    async adminEbaySetup(
        requestParameters: AdminEbayApiAdminEbaySetupRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayAccountResp>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminEbaySetup.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbaySetupPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminEbaySetupReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayAccountRespFromJSON(jsonValue))
        );
    }
    /**
     * Gets a fresh access token with the stored sign-in and reads the account from eBay.
     * Check the eBay connection
     */
    async adminEbayVerify(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminEbayAccountResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminEbayVerifyPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminEbayAccountRespFromJSON(jsonValue))
        );
    }
}
